import api from "@/api/api";
import request from "@/utils/request";

export const forgetPasswordJapan = (data: API.ForgetPasswordReq): Promise<API.ForgetPasswordRes> => {
  return request.post(api.system_forgetPasswordJapan, data);
};
